import React from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'react-collapsible'

// forked from:
// https://github.com/glennflanagan/react-responsive-accordion

class Accordion extends React.Component {
  constructor(props) {
    super(props)

    const openPosition = this.props.startPosition || 0

    this.state = {
      openPosition,
      closeAll: false,
    }

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
  }

  handleTriggerClick(position) {
    let closeAll = false

    if (this.props.closeable) {
      closeAll = (!this.state.closeAll && position === this.state.openPosition)
    }

    this.setState({
      openPosition: position,
      closeAll,
    })

    this.props.onTriggerClick(position)
  }

  render() {
    const nodes = this.props.children.map((node, index) => {
      const triggerWhenOpen = (node.props['data-trigger-when-open']) ? node.props['data-trigger-when-open'] : node.props['data-trigger']
      const triggerDisabled = (node.props['data-trigger-disabled']) || false

      return (
        <Collapsible
          key={`Collapsible${index}`}
          handleTriggerClick={this.handleTriggerClick}
          open={(!this.state.closeAll && this.state.openPosition === index)}
          trigger={node.props['data-trigger']}
          triggerWhenOpen={triggerWhenOpen}
          triggerDisabled={triggerDisabled}
          transitionTime={this.props.transitionTime}
          easing={this.props.easing}
          classParentString={this.props.classParentString}
          accordionPosition={index}
        >{node}
        </Collapsible>)
        }
      )

    return (<div>{nodes}</div>)
  }
}

Accordion.propTypes = {
  transitionTime: PropTypes.number,
  easing: PropTypes.string,
  startPosition: PropTypes.number,
  classParentString: PropTypes.string,
  onTriggerClick: PropTypes.func,
  closeable: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.shape({
    props: PropTypes.shape({
      'data-trigger': PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
      ]).isRequired,
      'data-triggerWhenOpen': PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
      ]),
      'data-triggerDisabled': PropTypes.bool,
    }),
  })),
}

Accordion.defaultProps = {
  closeable: true,
  onTriggerClick: () => {},
}

export default Accordion
